import React from "react";
import PulseLoader from "react-spinners/PulseLoader";

function StandardButton(props) {
  const Component = props.as || "div";
  return (
    <Component
      type={Component === "button" ? props.type || "button" : undefined}
      disabled={
        Component === "button"
          ? Boolean(props.disabled && !props.disabledClick)
          : undefined
      }
      title={props.title}
      className={`px-6 py-2.5 rounded-xl font-bold text-sm cursor-pointer ${
        props.color === "red"
          ? "bg-snow-red"
          : props.color === "green"
            ? "bg-snow-green"
            : props.color === "blue-gradient"
              ? "bg-gradient-to-br from-landing-page-gradient-blue-start to-landing-page-gradient-blue-end"
              : "bg-snow-blue-3"
      }
            ${
              props.disabled || props.loading
                ? "opacity-60 disabled:cursor-not-allowed disabled:opacity-50"
                : "hover:opacity-80 active:opacity-40"
            } ${props.className ?? ""}`}
      onClick={!props.disabled ? props.onClick : props.disabledClick}
      data-testid={props.testId ?? null}
    >
      {props.loading ? (
        <div className="w-full flex justify-center">
          <PulseLoader
            color={props.loaderColor || "#fffafa"}
            size={props.loaderSize || 5}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <div
          className={`font-bold text-snow-white text-center flex items-center justify-center
          ${props.fontSize === "lg" ? "text-lg" : "text-sm"}
        `}
        >
          {props.label ?? props.children}
        </div>
      )}
    </Component>
  );
}

export default StandardButton;
